import { HttpClient } from '@angular/common/http';
import {
  EnvironmentProviders,
  Injectable,
  inject,
  isDevMode,
  makeEnvironmentProviders,
} from '@angular/core';
import {
  Translation,
  TranslocoLoader,
  provideTransloco,
} from '@jsverse/transloco';
import { HOSPITAL_LOCALE, LOCALES } from './locale.service';

@Injectable({ providedIn: 'root' })
export class HttpTranslationLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);
  /**
   * `public/i18n/*.json` is not content-hashed by the Angular builder. A stable
   * URL therefore lets a browser reuse the previous release's catalogue while
   * loading the new hashed application bundle, which renders newly introduced
   * clinical labels as raw keys. One revision per application boot keeps normal
   * in-session reuse while forcing a fresh catalogue after every reload.
   */
  private readonly catalogueRevision = Date.now().toString(36);

  getTranslation(lang: string) {
    return this.http.get<Translation>(
      `/i18n/${lang}.json?v=${this.catalogueRevision}`,
    );
  }
}

export function provideAppTranslation(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideTransloco({
      config: {
      availableLangs: LOCALES.map((l) => l.code),
      // The language a tab opens in, so the first catalogue fetched is the one
      // shown. LocaleService applies the choice; this only has to agree with it.
      defaultLang: HOSPITAL_LOCALE,
      // English is the fallback: a missing Arabic key must render readable
      // English, never a raw key like `patients.census.title` on a clinical
      // screen. Silent fallback in production, loud in development.
      fallbackLang: 'en',
      missingHandler: {
        useFallbackTranslation: true,
        logMissingKey: isDevMode(),
        allowEmpty: false,
      },
      reRenderOnLangChange: true,
      prodMode: !isDevMode(),
    },
      loader: HttpTranslationLoader,
    }),
  ]);
}
